import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { CommitmentLevel } from '../types/onboarding'

const options: { value: CommitmentLevel; label: string; emoji: string; description: string }[] = [
  { value: 'all_in', label: "I'm all in", emoji: '🔥', description: 'Ready to make it a daily habit' },
  { value: 'pretty', label: 'Pretty committed', emoji: '💪', description: "I'll do my best most days" },
  { value: 'trying', label: 'Willing to try', emoji: '🌱', description: 'Starting small and building up' },
  { value: 'exploring', label: 'Just exploring', emoji: '👀', description: 'Seeing what tools are out there' },
]

export function CommitmentStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="How committed are you?"
      subtitle="There's no wrong answer - we'll meet you where you are"
      showContinue={false}
    >
      <SingleSelect
        options={options}
        value={data.commitmentLevel}
        onChange={(value) => goNext({ commitmentLevel: value })}
      />
    </StepContainer>
  )
}
